export default "__VITE_ASSET__CV8PNar8__"